import React from 'react';
import { Form, Grid, Segment, Label, Button, Icon, Divider } from 'semantic-ui-react';
import TRANSLATIONS from '@translations/translationNamespaces';
import { withTranslation } from 'react-i18next';
import { GithubPicker } from 'react-color';
import { TranslatableTextField, InputField, TranslatableRichTextField } from '../../../../../components';
import CounterItemModel from '../../../../models/elementModels/CounterElementModel/CounterItemModel';

class CounterElement extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onChangeTranslatableContent = this.onChangeTranslatableContent.bind(this);
    this.onChangeContent = this.onChangeContent.bind(this);
    this.onRemoveCounter = this.onRemoveCounter.bind(this);
    this.onAddCounter = this.onAddCounter.bind(this);
    this.onArrowUp = this.onArrowUp.bind(this);
    this.onArrowDown = this.onArrowDown.bind(this);
    this.onAnimationDurationChange = this.onAnimationDurationChange.bind(this);
  }

  onTranslatableChange(e, { name, value, language }) {
    const { onChange, sectionNumber, element } = this.props;

    onChange(prevState => ({
      offerSections: prevState.offerSections.reduce((acc, section) => {
        if (section.position === sectionNumber) {
          return acc.concat([
            {
              ...section,
              elements: section.elements.reduce((elementsAcc, el) => {
                if (element.position === el.position) {
                  return elementsAcc.concat([
                    {
                      ...el,
                      [name]: {
                        ...el[name],
                        [language]: value,
                      },
                    },
                  ]);
                }
                return elementsAcc.concat([el]);
              }, []),
            },
          ]);
        }
        return acc.concat([section]);
      }, []),
    }));
  }

  onChangeTranslatableContent(e, { name, value, language, innerElementPosition }) {
    const { onChange, sectionNumber, element } = this.props;

    onChange(prevState => ({
      offerSections: prevState.offerSections.reduce((acc, section) => {
        if (section.position === sectionNumber) {
          return acc.concat([
            {
              ...section,
              elements: section.elements.reduce((elementsAcc, el) => {
                if (element.position === el.position) {
                  return elementsAcc.concat([
                    {
                      ...el,
                      elements: el.elements.reduce((innerElementsAcc, innerElement) => {
                        if (innerElement.position === innerElementPosition) {
                          return innerElementsAcc.concat([
                            {
                              ...innerElement,
                              [name]: {
                                ...innerElement[name],
                                [language]: value,
                              },
                            },
                          ]);
                        }
                        return innerElementsAcc.concat([innerElement]);
                      }, []),
                    },
                  ]);
                }
                return elementsAcc.concat([el]);
              }, []),
            },
          ]);
        }
        return acc.concat([section]);
      }, []),
    }));
  }

  onChangeContent(e, { name, value, innerElementPosition }) {
    const { onChange, sectionNumber, element } = this.props;

    onChange(prevState => ({
      offerSections: prevState.offerSections.reduce((acc, section) => {
        if (section.position === sectionNumber) {
          return acc.concat([
            {
              ...section,
              elements: section.elements.reduce((elementsAcc, el) => {
                if (element.position === el.position) {
                  return elementsAcc.concat([
                    {
                      ...el,
                      elements: el.elements.reduce((innerElementsAcc, innerElement) => {
                        if (innerElement.position === innerElementPosition) {
                          return innerElementsAcc.concat([
                            {
                              ...innerElement,
                              [name]: value,
                            },
                          ]);
                        }
                        return innerElementsAcc.concat([innerElement]);
                      }, []),
                    },
                  ]);
                }
                return elementsAcc.concat([el]);
              }, []),
            },
          ]);
        }
        return acc.concat([section]);
      }, []),
    }));
  }

  onRemoveCounter(innerElementPosition) {
    const { onChange, sectionNumber, element } = this.props;

    // eslint-disable-next-line no-restricted-globals
    if (confirm(`Are you sure you want to remove counter? Counter element changes will be discarded.`)) {
      onChange(prevState => ({
        offerSections: prevState.offerSections.reduce((acc, section) => {
          if (section.position === sectionNumber) {
            return acc.concat([
              {
                ...section,
                elements: section.elements.reduce((elementsAcc, el) => {
                  if (element.position === el.position) {
                    return elementsAcc.concat([
                      {
                        ...el,
                        elements: el.elements.reduce((innerElementsAcc, innerElement) => {
                          if (innerElement.position === innerElementPosition) {
                            return innerElementsAcc;
                          }
                          if (innerElement.position > innerElementPosition) {
                            return innerElementsAcc.concat([{ ...innerElement, position: innerElement.position - 1 }]);
                          }
                          return innerElementsAcc.concat([innerElement]);
                        }, []),
                      },
                    ]);
                  }
                  return elementsAcc.concat([el]);
                }, []),
              },
            ]);
          }
          return acc.concat([section]);
        }, []),
      }));
    }
  }

  onAddCounter() {
    const { onChange, sectionNumber, element } = this.props;

    onChange(prevState => ({
      offerSections: prevState.offerSections.reduce((acc, section) => {
        if (section.position === sectionNumber) {
          return acc.concat([
            {
              ...section,
              elements: section.elements.reduce((elementsAcc, el) => {
                if (element.position === el.position) {
                  return elementsAcc.concat([
                    {
                      ...el,
                      elements: el.elements.concat([
                        {
                          ...CounterItemModel,
                          position: el?.elements?.[el?.elements?.length - 1]?.position + 1 || 1,
                          backendIndex: el?.elements?.length || 0,
                        },
                      ]),
                    },
                  ]);
                }
                return elementsAcc.concat([el]);
              }, []),
            },
          ]);
        }
        return acc.concat([section]);
      }, []),
    }));
  }

  onArrowUp(innerElementPosition) {
    const { onChange, sectionNumber, element } = this.props;

    onChange(prevState => ({
      offerSections: prevState.offerSections.reduce((acc, section) => {
        if (section.position === sectionNumber) {
          return acc.concat([
            {
              ...section,
              elements: section.elements.reduce((elementsAcc, el) => {
                if (element.position === el.position) {
                  return elementsAcc.concat([
                    {
                      ...el,
                      elements: el.elements.reduce((innerElementsAcc, innerElement) => {
                        const prevItem = el.elements.find(item => item.position === innerElementPosition - 1);
                        const matchingItem = el.elements.find(item => item.position === innerElementPosition);

                        if (innerElement.position === prevItem.position) {
                          return innerElementsAcc.concat({ ...matchingItem, position: prevItem.position });
                        }
                        if (innerElement.position === matchingItem.position) {
                          return innerElementsAcc.concat({ ...prevItem, position: matchingItem.position });
                        }
                        return innerElementsAcc.concat([innerElement]);
                      }, []),
                    },
                  ]);
                }
                return elementsAcc.concat([el]);
              }, []),
            },
          ]);
        }
        return acc.concat([section]);
      }, []),
    }));
  }

  onArrowDown(innerElementPosition) {
    const { onChange, sectionNumber, element } = this.props;

    onChange(prevState => ({
      offerSections: prevState.offerSections.reduce((acc, section) => {
        if (section.position === sectionNumber) {
          return acc.concat([
            {
              ...section,
              elements: section.elements.reduce((elementsAcc, el) => {
                if (element.position === el.position) {
                  return elementsAcc.concat([
                    {
                      ...el,
                      elements: el.elements.reduce((innerElementsAcc, innerElement) => {
                        const nextItem = el.elements.find(item => item.position === innerElementPosition + 1);
                        const matchingItem = el.elements.find(item => item.position === innerElementPosition);

                        if (innerElement.position === matchingItem.position) {
                          return innerElementsAcc.concat({ ...nextItem, position: matchingItem.position });
                        }
                        if (innerElement.position === nextItem.position) {
                          return innerElementsAcc.concat({ ...matchingItem, position: nextItem.position });
                        }
                        return innerElementsAcc.concat([innerElement]);
                      }, []),
                    },
                  ]);
                }
                return elementsAcc.concat([el]);
              }, []),
            },
          ]);
        }
        return acc.concat([section]);
      }, []),
    }));
  }

  onAnimationDurationChange(e, { name, value }) {
    const { onChange, sectionNumber, element } = this.props;

    onChange(prevState => ({
      offerSections: prevState.offerSections.reduce((acc, section) => {
        if (section.position === sectionNumber) {
          return acc.concat([
            {
              ...section,
              elements: section.elements.reduce((elementsAcc, el) => {
                if (element.position === el.position) {
                  return elementsAcc.concat([
                    {
                      ...el,
                      [name]: value,
                    },
                  ]);
                }
                return elementsAcc.concat([el]);
              }, []),
            },
          ]);
        }
        return acc.concat([section]);
      }, []),
    }));
  }

  render() {
    const { element, elementErrors, t, isViewMode } = this.props;

    return (
      <>
        <Form.Group>
          <Grid container stackable columns={2} divided>
            <TranslatableRichTextField
              type="text"
              name="subtitle"
              label={t('counter.subtitle')}
              errorMessage={elementErrors?.subtitle}
              value={element?.subtitle}
              icon="font"
              onChange={(e, { name, language, value }) => this.onTranslatableChange(e, { name, language, value })}
              disabled={isViewMode}
            />
          </Grid>
        </Form.Group>
        <Form.Group>
          <Grid container stackable columns={isViewMode ? 1 : 2} divided verticalAlign="middle">
            {isViewMode ? null : (
              <Grid.Column>
                <Button onClick={() => this.onAddCounter()}>
                  <Icon name="plus" />
                  {t('counter.newItem')}
                </Button>
              </Grid.Column>
            )}
            <InputField
              disabled={isViewMode}
              icon="clock"
              type="text"
              label={t('counter.animationDuration')}
              tooltip={t('tooltip.counter.animationDuration')}
              name="animationDuration"
              value={element.animationDuration}
              onChange={this.onAnimationDurationChange}
            />
          </Grid>
        </Form.Group>
        {element.elements.map(innerElement => (
          <Segment key={innerElement.position} className="pb-0">
            <Form.Group>
              <Grid container stackable columns={1} divided>
                <Grid.Row>
                  <Label className="mb-auto mt-auto">
                    {innerElement.position}. {t('counter.counter')}
                  </Label>
                  {isViewMode ? null : (
                    <>
                      <Button
                        icon
                        className="mr-2 ml-2"
                        disabled={innerElement.position === element.elements[0].position}
                        onClick={() => this.onArrowUp(innerElement.position)}
                      >
                        <Icon name="arrow up" />
                      </Button>
                      <Button
                        icon
                        className="mr-2 ml-2"
                        disabled={innerElement.position === element.elements[element.elements.length - 1].position}
                        onClick={() => this.onArrowDown(innerElement.position)}
                      >
                        <Icon name="arrow down" />
                      </Button>
                      <Button
                        className="mr-2 ml-2"
                        icon
                        color="red"
                        onClick={() => this.onRemoveCounter(innerElement.position)}
                      >
                        <Icon name="trash" />
                      </Button>
                    </>
                  )}
                </Grid.Row>
              </Grid>
            </Form.Group>
            <Divider />
            <Form.Group>
              <Grid container stackable columns={2} divided>
                <TranslatableTextField
                  icon="font"
                  label={t('counter.label')}
                  name="label"
                  disabled={isViewMode}
                  errorMessage={elementErrors?.elements?.[innerElement?.backendIndex]?.label}
                  value={innerElement.label}
                  onChange={(e, { name, language, value }) =>
                    this.onChangeTranslatableContent(e, {
                      name,
                      language,
                      value,
                      innerElementPosition: innerElement.position,
                    })
                  }
                />
              </Grid>
            </Form.Group>
            <Divider />
            <Form.Group>
              <Grid container stackable columns={3} divided>
                <InputField
                  icon="hashtag"
                  disabled={isViewMode}
                  type="number"
                  label={t('counter.countFrom')}
                  tooltip={t('tooltip.counter.countFrom')}
                  name="countFrom"
                  errorMessage={elementErrors?.elements?.[innerElement?.backendIndex]?.countFrom}
                  value={innerElement.countFrom}
                  onChange={(e, { name, value }) =>
                    this.onChangeContent(e, {
                      name,
                      value,
                      innerElementPosition: innerElement.position,
                    })
                  }
                />
                <InputField
                  icon="hashtag"
                  type="number"
                  disabled={isViewMode}
                  label={t('counter.countTo')}
                  tooltip={t('tooltip.counter.countTo')}
                  name="countTo"
                  errorMessage={elementErrors?.elements?.[innerElement?.backendIndex]?.countTo}
                  value={innerElement.countTo}
                  onChange={(e, { name, value }) =>
                    this.onChangeContent(e, {
                      name,
                      value,
                      innerElementPosition: innerElement.position,
                    })
                  }
                />
                <InputField
                  disabled={isViewMode}
                  icon="angle left"
                  type="text"
                  label={t('counter.prefix')}
                  name="prefix"
                  errorMessage={elementErrors?.elements?.[innerElement?.backendIndex]?.prefix}
                  value={innerElement.prefix}
                  onChange={(e, { name, value }) =>
                    this.onChangeContent(e, {
                      name,
                      value,
                      innerElementPosition: innerElement.position,
                    })
                  }
                />
              </Grid>

              <div hidden>
                <InputField
                  disabled={isViewMode}
                  hidden
                  icon="circle"
                  type="text"
                  label={t('counter.color')}
                  tooltip={t('tooltip.counter.color')}
                  name="color"
                  errorMessage={elementErrors?.elements?.[innerElement?.backendIndex]?.color}
                  value={innerElement.color}
                  onChange={(e, { name, value }) =>
                    this.onChangeContent(e, {
                      name,
                      value,
                      innerElementPosition: innerElement.position,
                    })
                  }
                />
                {isViewMode ? null : (
                  <Grid.Column>
                    <GithubPicker
                      triangle="hide"
                      width="auto"
                      color={innerElement?.color || '#000000'}
                      onChangeComplete={color => {
                        this.onChangeContent(false, {
                          name: 'color',
                          value: color?.hex,
                          innerElementPosition: innerElement.position,
                        });
                      }}
                    />
                  </Grid.Column>
                )}
              </div>
            </Form.Group>
          </Segment>
        ))}
      </>
    );
  }
}

export default withTranslation(TRANSLATIONS.OFFERS)(CounterElement);
